import { Theme } from 'config';

const styles = (theme: Theme) => ({
  header: {
    backgroundColor: `${theme.violet} !important`,
    color: '#FFF !important',
    fontSize: '1.15rem !important',
  },
  fieldGroup: {
    padding: '.5rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  label: {
    marginLeft: '.5rem',
  },
  submit: {
    backgroundColor: theme.violet,
    borderRadius: '1.5rem',
    color: '#fff ',
    fontSize: '.8rem',
    padding: '0.5rem 1.25rem',
    fontWeight: '500',
    lineHeight: '1.25rem',
    cursor: 'pointer',

    '&:focus': {
      outline: 'none',
    },
    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  message: {
    color: theme.coral,
    marginLeft: '1rem',
    fontSize: '.85rem',
  },
  disabled: {
    backgroundColor: `${theme.softGray} !important`,
    color: `${theme.darkGray} !important`,
    cursor: 'auto !important',
  },
  smallBtn: {
    width: '25% !important',
  },
  button: {
    border: 'none',
    backgroundColor: theme.violet,
    borderRadius: '1.5rem',
    color: '#fff !important',
    fontSize: '.8rem',
    marginTop: '1rem',
    opacity: 1,
    padding: '0.5rem 1.25rem',
    fontWeight: '500',
    lineHeight: '1.25rem',
    cursor: 'pointer',
    textAlign: 'center',

    '&:focus': {
      outline: 0,
    },
    '&:first-child': {
      marginLeft: '1rem`',
    },
    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
    '.selected': {
      opacity: 0.7,
    },
    '&.fluid': {
      flex: 1,
    },
    '&:disabled': {
      backgroundColor: theme.disabledBtnGray,
      color: '#f7f8f9 !important',
      pointerEvents: 'none !important',
      opacity: 0.6,
    },
  },
  '@global .ui.page.dimmer': {
    backgroundColor: 'rgba(0, 0, 0, .8)',
  },
});

export default styles;
